module.exports = __webpack_public_path__ + "static/img01-d63b7b08c8d60bdd1ddf85ef66046602.png";